export const medTimes = [
    'daily',
    '2 times daily',
    '3 times daily',
    '4 times daily',
    'every other day',
    'at bedtime',
    'every hour',
    'every 2 hours',
    'every 3 hours',
    'every 4 hours',
    'every 6 hours',
    'every 8 hours',
    'every 12 hours',
    'every 24 hours',
    'before every meal',
    'after every meal',
    '1 hour after every meal',
    'every morning',
    'every 4-6 hours',
    'constant infusion',
    'once a week',
    'every Monday, Wednesday, Friday',
    '2 times a week',
    '3 times a week',
    '1 time dose',
    'daily as directed',
    'as directed',
]